/* Loumont Quick Shop V1.9 — Dawn / FD Combined Listings tolerant integration.
   The sticky PDP button forwards to Dawn's original product form.
   Collection quick-add uses Shopify's Ajax Cart + Dawn cart-drawer rendering.
   Colors remain independent products managed by FD; NEVER fabricate a variant color ID.
*/
(() => {
  'use strict';
  if (window.__loumontQuickShopV1) return;
  window.__loumontQuickShopV1 = true;

  const $ = (sel, parent = document) => parent.querySelector(sel);
  // Textes traduits injectés par theme.liquid (repli : français)
  const lqsFallback = {"sold_out_short": "Rupture", "made_to_order": "Sur commande", "available": "Disponible", "close": "Fermer", "select_size": "Sélectionner une taille", "available_sizes": "Tailles disponibles", "add_to_cart": "AJOUTER AU PANIER", "view_product": "Voir la fiche produit", "no_size_needed": "Cet article ne nécessite pas de choisir une taille.", "several_options": "Cet article comporte plusieurs options : sélectionnez-les sur la fiche produit.", "adding": "AJOUT EN COURS…", "add_failed": "Impossible d’ajouter cet article.", "generic_error": "Une erreur est survenue.", "close_options": "Fermer les options", "current_color": "Couleur actuelle", "see_colors": "Voir les couleurs disponibles", "sold_out": "RUPTURE DE STOCK", "select_size_pdp": "Sélectionnez la taille sur la fiche produit.", "size_sync_failed": "La taille n’a pas pu être synchronisée. Sélectionnez-la sur la fiche produit.", "crossed_sizes": "Tailles barrées : rupture de stock.", "check_size": "Vérifiez la taille sélectionnée."};
  const lqsT = (key) => (window.LoumontI18n && window.LoumontI18n.quickShop && window.LoumontI18n.quickShop[key]) || lqsFallback[key] || '';
  const $$ = (sel, parent = document) => Array.from(parent.querySelectorAll(sel));
  const root = () => ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/?$/, '/');
  const isSizeOnly = (d) => d && d.sizeIndex >= 0 && d.optionCount === 1;
  const canOneClick = (d) => d && d.variants.length === 1 && d.optionCount === 1 && d.sizeIndex === -1;
  const standardQty = (v) => Number(v.min || 1) === 1 && Number(v.increment || 1) === 1 && (!v.max || Number(v.max) >= 1);

  function getData(parent) {
    const el = $('[data-lqs-product]', parent);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { console.warn('Loumont Quick Shop product JSON', e); return null; }
  }
  function availableSizes(data) {
    const bySize = new Map();
    (data.variants || []).forEach(v => {
      if (v.size !== null && !bySize.has(v.size)) bySize.set(v.size, v);
    });
    return Array.from(bySize.values());
  }
  function stateLabel(v) {
    if (!v.available) return lqsT('sold_out_short');
    if (v.inventoryManaged && Number(v.inventory) <= 0 && v.policyContinue) return lqsT('made_to_order');
    return lqsT('available');
  }
  function displayError(el, message) {
    if (!el) return;
    el.textContent = message || '';
    el.hidden = !message;
  }

  // CARD MODAL ---------------------------------------------------------------
  let modal = null;
  let modalData = null;
  let modalChosen = null;
  let modalBusy = false;
  let modalPreviouslyFocused = null;

  function ensureModal() {
    if (modal) return modal;
    modal = document.createElement('div');
    modal.className = 'lqs-modal';
    modal.hidden = true;
    modal.innerHTML = `
      <button class="lqs-modal__shade" type="button" aria-label="${lqsT('close')}" data-lqs-modal-close></button>
      <div class="lqs-modal__sheet" role="dialog" aria-modal="true" aria-labelledby="lqs-modal-title" tabindex="-1">
        <div class="lqs-modal__head">
          <h2 class="lqs-modal__title" id="lqs-modal-title"></h2>
          <button type="button" class="lqs-modal__close" aria-label="${lqsT('close')}" data-lqs-modal-close>×</button>
        </div>
        <p class="lqs-modal__subtitle">${lqsT('select_size')}</p>
        <div class="lqs-modal__sizes" role="group" aria-label="${lqsT('available_sizes')}"></div>
        <p class="lqs-modal__note"></p>
        <button type="button" class="lqs-modal__buy" data-lqs-modal-buy><span>${lqsT('add_to_cart')}</span><span data-lqs-modal-price></span></button>
        <p class="lqs-modal__error" role="alert" hidden></p>
        <a class="lqs-modal__link" data-lqs-modal-product-link href="#">${lqsT('view_product')}</a>
      </div>`;
    document.body.appendChild(modal);
    modal.addEventListener('click', (e) => {
      if (e.target.closest('[data-lqs-modal-close]')) closeModal();
      const b = e.target.closest('[data-lqs-modal-size]');
      if (b) {
        const chosen = (modalData.variants || []).find(v => String(v.id) === b.dataset.lqsModalSize);
        if (!chosen || !chosen.available || !standardQty(chosen) || modalBusy) return;
        modalChosen = chosen;
        // Une taille disponible déclenche directement l'ajout AJAX, sans second bouton.
        submitCard();
      }
      if (e.target.closest('[data-lqs-modal-buy]')) submitCard();
    });
    return modal;
  }
  function closeModal() {
    if (modalBusy || !modal) return;
    modal.hidden = true;
    document.body.classList.remove('lqs-modal-open');
    if (modalPreviouslyFocused && document.contains(modalPreviouslyFocused)) modalPreviouslyFocused.focus();
  }
  function openModal(button) {
    const card = button.closest('.loumont-quick-card');
    if (!card) return;
    const data = getData($('.card__inner', card) || card);
    if (!data) return;
    modalData = data;
    modalChosen = null;
    modalBusy = false;
    modalPreviouslyFocused = button;
    ensureModal();
    $('#lqs-modal-title', modal).textContent = data.title;
    $('[data-lqs-modal-product-link]', modal).href = data.url;
    displayError($('.lqs-modal__error', modal), '');
    modal.hidden = false;
    document.body.classList.add('lqs-modal-open');
    updateModal();
    $('.lqs-modal__sheet', modal).focus();
  }
  function updateModal() {
    if (!modalData) return;
    const sizes = $('.lqs-modal__sizes', modal);
    const sub = $('.lqs-modal__subtitle', modal);
    const note = $('.lqs-modal__note', modal);
    const buy = $('[data-lqs-modal-buy]', modal);
    const productLink = $('[data-lqs-modal-product-link]', modal);
    sizes.replaceChildren();
    const sizeOnly = isSizeOnly(modalData);
    const oneClick = canOneClick(modalData);
    sub.hidden = !sizeOnly;
    // Avec des tailles, le clic sur la taille ajoute directement au panier.
    // Le CTA reste réservé aux produits qui n'ont qu'une seule variante.
    buy.hidden = sizeOnly || !oneClick;
    productLink.hidden = sizeOnly || oneClick;
    note.textContent = '';

    if (sizeOnly) {
      availableSizes(modalData).forEach(v => {
        const b = document.createElement('button');
        const isChosen = !!modalChosen && String(modalChosen.id) === String(v.id);
        b.type = 'button';
        b.className = 'lqs-modal__size';
        b.dataset.lqsModalSize = String(v.id);
        b.textContent = v.size;
        b.title = `${v.size} — ${stateLabel(v)}`;
        b.setAttribute('aria-label', `${v.size} — ${stateLabel(v)}`);
        b.setAttribute('aria-pressed', String(isChosen));
        if (modalBusy && isChosen) b.setAttribute('aria-busy', 'true');
        b.disabled = !v.available || !standardQty(v) || modalBusy;
        sizes.appendChild(b);
      });
    } else if (oneClick) {
      modalChosen = modalData.variants[0];
      note.textContent = lqsT('no_size_needed');
    } else {
      note.textContent = lqsT('several_options');
    }
    note.hidden = !note.textContent;
    const valid = oneClick && modalChosen && modalChosen.available && standardQty(modalChosen);
    buy.disabled = !valid || modalBusy;
    buy.firstElementChild.textContent = modalBusy ? lqsT('adding') : lqsT('add_to_cart');
    $('[data-lqs-modal-price]', modal).textContent = modalChosen ? modalChosen.price : '';
  }

  async function addToExistingCart(variantId) {
    const drawer = $('cart-drawer') || $('cart-notification');
    const sections = drawer && typeof drawer.getSectionsToRender === 'function'
      ? drawer.getSectionsToRender().map(s => s.id).filter(Boolean)
      : ['cart-drawer', 'cart-icon-bubble'];
    const form = new FormData();
    form.append('id', String(variantId));
    form.append('quantity', '1');
    form.append('sections', sections.join(','));
    form.append('sections_url', window.location.pathname);
    const response = await fetch(`${root()}cart/add.js`, {
      method: 'POST', body: form, headers: { 'Accept': 'application/json' }
    });
    const data = await response.json();
    if (!response.ok || data.status >= 400) throw new Error(data.description || data.message || lqsT('add_failed'));
    if (drawer && typeof drawer.renderContents === 'function' && data.sections && sections.every(s => data.sections[s] != null)) {
      drawer.classList.remove('is-empty');
      drawer.renderContents(data);
      if (typeof drawer.open === 'function') drawer.open();
      return;
    }
    // A custom cart extension may not offer Dawn's renderContents protocol.
    // Never pretend the cart updated: redirect to the true cart in that case.
    window.location.assign(`${root()}cart`);
  }
  async function submitCard() {
    if (modalBusy || !modalChosen || !modalChosen.available || !standardQty(modalChosen)) return;
    modalBusy = true;
    updateModal();
    displayError($('.lqs-modal__error', modal), '');
    try {
      await addToExistingCart(modalChosen.id);
      modalBusy = false;
      closeModal();
    } catch (e) {
      modalBusy = false;
      displayError($('.lqs-modal__error', modal), e.message || lqsT('generic_error'));
      updateModal();
    }
  }

  // STICKY PRODUCT BAR -------------------------------------------------------
  const initialized = new WeakSet();
  function getOriginalButton(sectionId) {
    return document.getElementById(`ProductSubmitButton-${sectionId}`);
  }
  function getVariantInput(sectionId) {
    const form = document.getElementById(`product-form-${sectionId}`);
    return form && $('[name="id"].product-variant-id', form);
  }
  function getVariantControls(sectionId) {
    return document.getElementById(`variant-selects-${sectionId}`);
  }
  function nativeSelectSize(sectionId, name) {
    const picker = getVariantControls(sectionId);
    if (!picker) return false;
    // Only the Size/Taille fieldset/select, not another option accidentally named XS.
    for (const fieldset of $$('fieldset', picker)) {
      const legend = $('legend', fieldset);
      if (!legend || !/\b(size|taille)\b/i.test(legend.textContent)) continue;
      const radio = $$('input[type="radio"]', fieldset).find(i => i.value.trim() === name);
      if (radio && !radio.disabled) { radio.click(); return true; }
      const label = $$('label', fieldset).find(l => l.textContent.trim() === name);
      if (label) { label.click(); return true; }
    }
    for (const container of $$('.product-form__input--dropdown', picker)) {
      const label = $('label.form__label', container);
      if (!label || !/\b(size|taille)\b/i.test(label.textContent)) continue;
      const select = $('select', container);
      if (!select) continue;
      const option = Array.from(select.options).find(o => o.value === name || o.textContent.trim() === name);
      if (!option || option.disabled) return false;
      select.value = option.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }
    return false;
  }
  let stickyBackdrop = null;
  function getStickyBackdrop() {
    if (stickyBackdrop && stickyBackdrop.isConnected) return stickyBackdrop;
    stickyBackdrop = document.createElement('button');
    stickyBackdrop.type = 'button';
    stickyBackdrop.className = 'lqs-sticky__backdrop';
    stickyBackdrop.setAttribute('aria-label', lqsT('close_options'));
    stickyBackdrop.hidden = true;
    stickyBackdrop.addEventListener('click', () => {
      $$('[data-lqs-sticky]').forEach(closeStickyPanels);
    });
    document.body.appendChild(stickyBackdrop);
    return stickyBackdrop;
  }
  function closeStickyPanels(bar) {
    $$('[data-lqs-color-panel], [data-lqs-size-panel]', bar).forEach(p => p.hidden = true);
    $$('[data-lqs-color-trigger], [data-lqs-size-trigger]', bar).forEach(b => b.setAttribute('aria-expanded', 'false'));
    bar.classList.remove('is-panel-open');
    if (stickyBackdrop && !document.querySelector('.lqs-sticky.is-panel-open')) stickyBackdrop.hidden = true;
  }
  function showStickyPanel(bar, type) {
    const panel = $(`[data-lqs-${type}-panel]`, bar);
    const button = $(`[data-lqs-${type}-trigger]`, bar);
    if (!panel || !button) return;
    const shouldOpen = panel.hidden;
    // Never display two overlapping option panels.
    $$('[data-lqs-sticky]').forEach(closeStickyPanels);
    if (shouldOpen) {
      getStickyBackdrop().hidden = false;
      panel.hidden = false;
      bar.classList.add('is-panel-open');
      button.setAttribute('aria-expanded', 'true');
    }
  }
  function nativeColorGroup(bar, data) {
    const section = document.getElementById(`ProductInfo-${bar.dataset.sectionId}`);
    if (!section) return [];
    // Restrict scanning to storefront markup that identifies itself as FD/FittDesign.
    // We don't infer colors from product titles or create a parallel list manually.
    const roots = $$('[id*="fitt" i], [class*="fitt" i], [id*="combined" i], [class*="combined" i], [class*="fd-" i], [id*="fd-" i], [id*="fd_" i], [class*="fd_" i], [id*="product-groups" i]', section)
      .filter(el => !bar.contains(el));
    const found = [];
    const seen = new Set();
    for (const container of roots) {
      const anchors = $$('a[href]', container);
      for (const a of anchors) {
        let u;
        try { u = new URL(a.href, window.location.href); } catch (e) { continue; }
        if (u.origin !== window.location.origin || !/\/products\/[^/]+/.test(u.pathname)) continue;
        if (seen.has(u.pathname)) continue;
        seen.add(u.pathname);
        const label = a.getAttribute('data-label') || a.getAttribute('aria-label') || a.getAttribute('title') ||
          a.querySelector('img')?.getAttribute('alt') || a.textContent.trim() ||
          decodeURIComponent(u.pathname.split('/products/')[1].split('/')[0]).replace(/-/g, ' ');
        found.push({ href: u.href, name: label.trim(), original: a, current: u.pathname === new URL(data.url, location.origin).pathname });
      }
      if (found.length >= 2) break;
    }
    if (found.length && !found.some(x => x.current)) {
      found.unshift({ href: new URL(data.url, window.location.origin).href, name: lqsT('current_color'), original: null, current: true });
    }
    return found;
  }
  // FD provides the relationship, Shopify provides the full product photography.
  // We fetch the public .js for the real featured image: FD swatches can be plain
  // colors or tiny swatch icons, which are NOT the product photos requested.
  const lqsProductImages = new Map();

  function validPhotoURL(candidate) {
    if (!candidate || typeof candidate !== 'string') return '';
    try {
      const url = new URL(candidate, window.location.origin);
      return /^https?:$/.test(url.protocol) ? url.href : '';
    } catch (e) { return ''; }
  }

  function getProductPhoto(item) {
    let url;
    try { url = new URL(item.href, window.location.origin); } catch (e) { return Promise.resolve(''); }
    if (url.origin !== window.location.origin) return Promise.resolve('');
    const match = url.pathname.match(/^(.*\/products\/[^/]+)\/?$/);
    if (!match) return Promise.resolve('');
    const key = match[1];
    if (lqsProductImages.has(key)) return lqsProductImages.get(key);
    const promise = fetch(`${key}.js`, {
      credentials: 'same-origin', headers: { Accept: 'application/json' }
    }).then(res => {
      if (!res.ok) throw new Error('Image produit indisponible');
      return res.json();
    }).then(product => {
      const raw = product.featured_image || product.image || (product.images && product.images[0]);
      return validPhotoURL(typeof raw === 'string' ? raw : (raw && (raw.src || raw.url)));
    }).catch(() => '');
    lqsProductImages.set(key, promise);
    return promise;
  }

  function currentColorLabel(bar, data, list) {
    const selected = list.find(item => item.current);
    if (selected && selected.name && !/^couleur actuelle$/i.test(selected.name.trim())) {
      return selected.name.trim();
    }
    // FD's storefront can expose "COLOR: BLACK" even before the links are ready.
    const info = document.getElementById(`ProductInfo-${bar.dataset.sectionId}`);
    if (info) {
      const nodes = $$('[class*="fitt" i], [class*="combined" i], [class*="fd-" i], [id*="fitt" i]', info).filter(node => !bar.contains(node));
      for (const node of nodes) {
        const match = (node.textContent || '').match(/(?:color|couleur)\s*:\s*([^\n\r]{1,40})/i);
        if (match) {
          const label = match[1].trim().split(/\s{2,}/)[0].trim();
          if (label && label.length <= 28) return label;
        }
      }
    }
    // No invented color associations: keep a readable fallback.
    return data.title || 'Choisir';
  }

  function setupColors(bar, data) {
    const list = nativeColorGroup(bar, data);
    const wrap = $('[data-lqs-color-wrap]', bar);
    const panel = $('[data-lqs-color-panel]', bar);
    const preview = $('[data-lqs-color-value]', bar);
    if (!wrap || !panel || !preview) return;
    const info = document.getElementById(`ProductInfo-${bar.dataset.sectionId}`);
    const nativeFd = info && $('[id*="fitt" i], [class*="fitt" i], [id*="fd_" i], [id*="fd-" i], [class*="fd-" i]', info);
    wrap.hidden = list.length < 2 && !nativeFd;
    panel.replaceChildren();
    // The collapsed color picker keeps the color name (e.g. BLACK).
    // The two real product photos appear only when the picker is opened.
    preview.textContent = currentColorLabel(bar, data, list);

    if (list.length < 2) {
      if (nativeFd) {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'lqs-sticky__color';
        button.textContent = lqsT('see_colors');
        button.addEventListener('click', () => {
          closeStickyPanels(bar);
          nativeFd.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
        panel.appendChild(button);
      }
      return;
    }

    const grid = document.createElement('div');
    grid.className = 'lqs-sticky__colors';
    panel.appendChild(grid);
    list.forEach(item => {
      const link = document.createElement('a');
      link.href = item.href;
      link.className = 'lqs-sticky__color';
      link.setAttribute('aria-label', `Choisir ${item.name}`);
      link.setAttribute('aria-current', String(item.current));
      const fallback = document.createElement('span');
      fallback.className = 'lqs-sticky__color-fallback';
      fallback.textContent = item.name;
      link.appendChild(fallback);
      link.addEventListener('click', event => {
        if (item.current) { event.preventDefault(); closeStickyPanels(bar); return; }
        // Preserve FD's own linked-product click handling (quick switching).
        // If FD doesn't intercept, the real product link navigates normally.
        if (item.original && item.original.isConnected) {
          event.preventDefault();
          item.original.click();
        }
      });
      grid.appendChild(link);

      getProductPhoto(item).then(src => {
        if (!src || !link.isConnected) return;
        const img = document.createElement('img');
        img.className = 'lqs-sticky__color-photo';
        img.alt = item.name;
        img.loading = 'lazy';
        img.decoding = 'async';
        img.src = src;
        link.replaceChildren(img);
      });
    });
  }

  function initSticky(bar) {
    if (initialized.has(bar)) return;
    initialized.add(bar);
    const data = getData(bar);
    if (!data) return;
    const sectionId = bar.dataset.sectionId;
    const input = getVariantInput(sectionId);
    const nativeButton = getOriginalButton(sectionId);
    if (!input || !nativeButton || bar.closest('.quick-add-modal')) return;
    const sizeOnly = isSizeOnly(data);
    const sizeWrap = $('[data-lqs-size-wrap]', bar);
    sizeWrap.hidden = !sizeOnly;
    const panel = $('[data-lqs-size-panel]', bar);
    const value = $('[data-lqs-size-value]', bar);
    const price = $('[data-lqs-price]', bar);
    const buy = $('[data-lqs-buy]', bar);
    const error = $('[data-lqs-error]', bar);
    let currentId = String(input.value || data.selectedId);
    let wantedId = null;
    let originalTop = null;

    function sync() {
      const currentInput = getVariantInput(sectionId) || input;
      const currentButton = getOriginalButton(sectionId) || nativeButton;
      currentId = String(currentInput.value || data.selectedId);
      const v = data.variants.find(v => String(v.id) === currentId);
      if (v) {
        price.textContent = v.price;
        value.textContent = v.size || 'Choisir';
        $$('[data-lqs-sticky-variant]', panel).forEach(b => b.setAttribute('aria-pressed', String(b.dataset.lqsStickyVariant === currentId)));
      }
      if (wantedId === currentId) wantedId = null;
      buy.disabled = !!wantedId || currentButton.disabled || !v?.available;
      $('[data-lqs-buy-label]', bar).textContent = v && !v.available ? lqsT('sold_out') : lqsT('add_to_cart');
    }
    if (sizeOnly) {
      const sizes = document.createElement('div');
      sizes.className = 'lqs-sticky__sizes';
      availableSizes(data).forEach(v => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'lqs-sticky__size';
        b.textContent = v.size;
        b.title = `${v.size} — ${stateLabel(v)}`;
        b.setAttribute('aria-label', `${v.size} — ${stateLabel(v)}`);
        b.dataset.lqsStickyVariant = String(v.id);
        b.disabled = !v.available || !standardQty(v);
        b.addEventListener('click', () => {
          displayError(error, '');
          wantedId = String(v.id);
          if (!nativeSelectSize(sectionId, v.size)) {
            wantedId = null;
            displayError(error, lqsT('select_size_pdp'));
            getVariantControls(sectionId)?.scrollIntoView({ behavior: 'smooth', block: 'center' });
          } else {
            price.textContent = v.price;
            value.textContent = v.size;
          }
          closeStickyPanels(bar);
          sync();
          [120, 350, 750].forEach(delay => window.setTimeout(sync, delay));
          window.setTimeout(() => {
            if (wantedId && wantedId !== String((getVariantInput(sectionId) || input).value)) {
              wantedId = null;
              displayError(error, lqsT('size_sync_failed'));
              sync();
            }
          }, 1300);
        });
        sizes.appendChild(b);
      });
      panel.appendChild(sizes);
      const note = document.createElement('p');
      note.className = 'lqs-sticky__note';
      note.textContent = lqsT('crossed_sizes');
      panel.appendChild(note);
    }
    setupColors(bar, data);
    $('[data-lqs-size-trigger]', bar)?.addEventListener('click', () => showStickyPanel(bar, 'size'));
    $('[data-lqs-color-trigger]', bar)?.addEventListener('click', () => showStickyPanel(bar, 'color'));
    buy.addEventListener('click', () => {
      if (buy.disabled) return;
      displayError(error, '');
      closeStickyPanels(bar);
      const currentInput = getVariantInput(sectionId) || input;
      const currentButton = getOriginalButton(sectionId) || nativeButton;
      const id = String(currentInput.value);
      if (!id || wantedId || currentButton.disabled) {
        displayError(error, lqsT('check_size'));
        return;
      }
      // Crucial: reuse Dawn product-form submission and its existing cart drawer.
      currentButton.click();
    });
    // Keep the bar in sync when the customer changes a Shopify variant outside it.
    const attrObserver = new MutationObserver(sync);
    attrObserver.observe(input, {attributes:true, attributeFilter:['value','disabled']});
    document.addEventListener('change', (e) => {
      if (e.target.matches && e.target.matches(`#product-form-${sectionId} input.product-variant-id`)) sync();
    });
    const variantPicker = getVariantControls(sectionId);
    variantPicker?.addEventListener('change', () => { window.setTimeout(sync, 80); window.setTimeout(sync, 250); });

    function visibility() {
      if (!bar.isConnected) {
        window.removeEventListener('scroll', visibility);
        window.removeEventListener('resize', visibility);
        attrObserver.disconnect();
        return;
      }
      const rect = (getOriginalButton(sectionId) || nativeButton).getBoundingClientRect();
      // Hide early after a small amount of vertical scrolling, even before
      // the native Add to cart button is visible. Edit 330 to adjust:
      // 150 = disappears sooner; 400 = disappears later.
      const hideAfterScroll = 330;
      const show = window.scrollY < hideAfterScroll && rect.top > window.innerHeight - 18;
      bar.classList.toggle('is-invisible', !show);
      if (!show) closeStickyPanels(bar);
    }
    bar.hidden = false;
    sync();
    visibility();
    window.addEventListener('scroll', visibility, { passive: true });
    window.addEventListener('resize', visibility, { passive: true });
    // FD may render its app widget after page-load.
    window.setTimeout(() => setupColors(bar, data), 700);
    window.setTimeout(() => setupColors(bar, data), 1900);
  }
  function scan() { $$('[data-lqs-sticky]').forEach(initSticky); }

  // COLLECTION GRID: exact mouse/photo hover, including Dawn's whole-card
  // anchor::after overlay. Hovering .card__inner itself is not reliable because
  // the overlay can belong to the outer .card__content instead.
  let mouseVisiblePlus = null;
  function showMousePlus(button) {
    if (mouseVisiblePlus === button) return;
    if (mouseVisiblePlus) mouseVisiblePlus.classList.remove('is-mouse-visible');
    mouseVisiblePlus = button || null;
    if (mouseVisiblePlus) mouseVisiblePlus.classList.add('is-mouse-visible');
  }
  function trackPhotoMouse(e) {
    // Ignore touch-originated pointer events; touch has its own swipe handler.
    if (e.pointerType === 'touch') return;
    const target = e.target;
    const card = target && typeof target.closest === 'function'
      ? target.closest('.loumont-quick-card') : null;
    if (!card || !Number.isFinite(e.clientX) || !Number.isFinite(e.clientY)) {
      showMousePlus(null);
      return;
    }
    const photo = $('.card__inner', card);
    const button = photo && $('[data-lqs-card-plus]', photo);
    if (!photo || !button) { showMousePlus(null); return; }
    const rect = photo.getBoundingClientRect();
    const onPhoto = rect.width > 0 && rect.height > 0 &&
      e.clientX >= rect.left && e.clientX <= rect.right &&
      e.clientY >= rect.top && e.clientY <= rect.bottom;
    showMousePlus(onPhoto ? button : null);
  }
  // Pointer events bubble from the overlay link to the document even when the
  // photo itself never receives mouseenter/mouseover.
  document.addEventListener('pointerover', trackPhotoMouse, {capture:true, passive:true});
  document.addEventListener('pointermove', trackPhotoMouse, {capture:true, passive:true});
  document.addEventListener('pointerout', e => {
    if (!e.relatedTarget) showMousePlus(null);
  }, {capture:true, passive:true});
  // The photo can move away beneath a stationary pointer during page scrolling.
  window.addEventListener('scroll', () => showMousePlus(null), {passive:true});
  window.addEventListener('blur', () => showMousePlus(null));

  // COLLECTION GRID: show + after a real finger swipe across a product photo.
  // Do not preventDefault: regular scrolling, carousels and product links stay native.
  // No touch gesture is needed on desktop: CSS handles mouse hover.
  const touchRevealDelay = 2800; // milliseconds after last reveal
  let touchedPhoto = null;
  let revealedPlus = null;
  let revealTimeout = null;

  function revealCardPlus(button) {
    if (revealedPlus && revealedPlus !== button) revealedPlus.classList.remove('is-touch-visible');
    revealedPlus = button;
    button.classList.add('is-touch-visible');
    if (revealTimeout !== null) window.clearTimeout(revealTimeout);
    revealTimeout = window.setTimeout(() => {
      button.classList.remove('is-touch-visible');
      if (revealedPlus === button) revealedPlus = null;
      revealTimeout = null;
    }, touchRevealDelay);
  }
  document.addEventListener('touchstart', e => {
    touchedPhoto = null;
    if (e.touches.length !== 1) return;
    const target = e.target;
    if (!target || typeof target.closest !== 'function') return;
    // A swipe starts on the product PHOTO, not on the tile's name/price/actions.
    const card = target.closest('.loumont-quick-card');
    const photo = card && $('.card__inner', card);
    if (!photo || target.closest('button, input, select, textarea, [role="button"]')) return;
    const touch = e.changedTouches[0];
    if (!touch) return;
    // A card link may cover the photo while belonging to a sibling node.
    // Use touch coordinates rather than target.closest('.card__inner').
    const rect = photo.getBoundingClientRect();
    if (touch.clientX < rect.left || touch.clientX > rect.right ||
        touch.clientY < rect.top || touch.clientY > rect.bottom) return;
    touchedPhoto = { photo, id: touch.identifier, x: touch.clientX, y: touch.clientY };
  }, { capture:true, passive:true });
  document.addEventListener('touchmove', e => {
    if (!touchedPhoto || !touchedPhoto.photo.isConnected) return;
    const touch = Array.from(e.changedTouches).find(t => t.identifier === touchedPhoto.id);
    if (!touch) return;
    const dx = touch.clientX - touchedPhoto.x;
    const dy = touch.clientY - touchedPhoto.y;
    // Prevent false reveals on short, normal taps (12 pixels minimum travel).
    if ((dx * dx + dy * dy) < 144) return;
    const button = $('[data-lqs-card-plus]', touchedPhoto.photo);
    if (button) revealCardPlus(button);
    // Only one reveal per swipe; the visibility persists briefly after lifting the finger.
    touchedPhoto = null;
  }, { capture:true, passive:true });
  document.addEventListener('touchend', () => { touchedPhoto = null; }, { capture:true, passive:true });
  document.addEventListener('touchcancel', () => { touchedPhoto = null; }, { capture:true, passive:true });

  // Dawn (or a card customisation) can place a whole-card link ABOVE the +.
  // In that case the browser targets the link instead of the visible button.
  // Detect a click in the button's rectangle even when another card layer is
  // the event target, so the click opens the size selector rather than the PDP.
  function getCardPlusFromEvent(e) {
    const target = e.target;
    if (!target || typeof target.closest !== 'function') return null;
    // The + occupies space even when fully transparent. Do not hijack a normal
    // photo tap in that invisible zone: only active (hover/swipe/focus) + counts.
    const isShown = button => button && window.getComputedStyle(button).pointerEvents !== 'none';
    const directPlus = target.closest('[data-lqs-card-plus]');
    if (isShown(directPlus)) return directPlus;
    const card = target.closest('.loumont-quick-card');
    if (!card || !Number.isFinite(e.clientX) || !Number.isFinite(e.clientY)) return null;
    return $$('[data-lqs-card-plus]', card).find(button => {
      if (!isShown(button)) return false;
      const r = button.getBoundingClientRect();
      return r.width > 0 && r.height > 0 &&
        e.clientX >= r.left && e.clientX <= r.right &&
        e.clientY >= r.top && e.clientY <= r.bottom;
    }) || null;
  }

  // Capture-phase handlers run before Dawn's bubbling card-link handlers.
  // Do not preventDefault on pointerdown: a normal touch still produces click.
  document.addEventListener('pointerdown', e => {
    if (getCardPlusFromEvent(e)) e.stopPropagation();
  }, true);
  document.addEventListener('click', e => {
    const plus = getCardPlusFromEvent(e);
    if (!plus) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    openModal(plus);
  }, true);

  document.addEventListener('click', e => {
    $$('[data-lqs-sticky]').forEach(bar => { if (!bar.contains(e.target)) closeStickyPanels(bar); });
  });
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') {
      if (modal && !modal.hidden) closeModal();
      $$('[data-lqs-sticky]').forEach(closeStickyPanels);
    }
    if (e.key === 'Tab' && modal && !modal.hidden) {
      const focusable = $$('button:not([disabled]),a[href]', modal).filter(el => !el.closest('[hidden]'));
      if (!focusable.length) return;
      const first = focusable[0], last = focusable[focusable.length-1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });
  // Re-initialize when FD Quick Switching swaps the product section with AJAX.
  let pending = false;
  const watch = new MutationObserver(() => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => { pending = false; scan(); });
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => { scan(); watch.observe(document.body, { childList:true, subtree:true }); }, {once:true});
  } else {
    scan(); watch.observe(document.body, { childList:true, subtree:true });
  }
})();
